import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { AccountsState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: AccountsState = {
  accounts:[],
  protocolList:[{id:1, name:'HTTP'}, {id:2, name:'SMPP'}]
};


export const accounts: Module<AccountsState,RootState> = {
    state,
    getters,
    actions,
    mutations
};